let signType;

export const SIGN_TYPE = {
    SIGNIN: 'signin',
    SIGNUP: 'signup',
};

export const SIGN_TYPE_EVENT = {
    CHANGE_TYPE: 'sign-type:change',
};

export function getSignType() {
    return signType;
}

export function setSignType(updatedSignType) {
    signType = updatedSignType;
}
